export default "__VITE_ASSET__590f539b__"